import { apiWithToken } from '../api';

const resouceUrl = '/observacao';
const token = localStorage.getItem('@token');
let api = apiWithToken(token)

export const load = async (params) => {
  const queryString = window.location.search;
  const urlParams = new URLSearchParams(queryString);
  let page = urlParams.has('page')
    ? { page: urlParams.get('page') }
    : {};
  let search = urlParams.has('search')
    ? { search: urlParams.get('search') }
    : {};
  return await api.get(`${resouceUrl}`, {
    params: {
      ...params,
      ...page,
      ...search
    }
  })
}
export const select = async () => {

  return await api.get(`${resouceUrl}?fields=id,nome&raw_list`);
};

export const show = async (id) => {
  return await api.get(`${resouceUrl}/${id}`);
}

export const update = async (id, observacao) => {
  return await api.put(`${resouceUrl}/${id}`, observacao);
}


export const store = async (observacao) => {
  let response = await api.post(resouceUrl , observacao);
  return response;
}

export const destroy = async (id) => {
  return await api.delete(`${resouceUrl}/${id}`);
}
